import React from "react";

/** A large, slow-drifting soft wave motif for hero backgrounds and ecosystem. */
export default function WaveMotif({ className = "", opacity = 0.5 }) {
  return (
    <svg
      className={`pointer-events-none select-none ${className}`}
      viewBox="0 0 1440 400"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="wm-1" x1="0" x2="1" y1="0" y2="0.2">
          <stop offset="0%" stopColor="#4e2957" stopOpacity="0.28" />
          <stop offset="35%" stopColor="#1a4c8e" stopOpacity="0.32" />
          <stop offset="65%" stopColor="#2eb7ab" stopOpacity="0.30" />
          <stop offset="85%" stopColor="#91a33a" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#eabe1d" stopOpacity="0.18" />
        </linearGradient>
        <linearGradient id="wm-2" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="#1a4c8e" stopOpacity="0.10" />
          <stop offset="100%" stopColor="#2eb7ab" stopOpacity="0.10" />
        </linearGradient>
      </defs>
      <g style={{ opacity }}>
        <path
          d="M0,220 C240,120 480,340 720,220 C960,100 1200,320 1440,200 L1440,400 L0,400 Z"
          fill="url(#wm-1)"
        />
        <path
          d="M0,280 C260,200 520,360 780,260 C1020,168 1220,340 1440,260 L1440,400 L0,400 Z"
          fill="url(#wm-2)"
        />
        <path
          d="M0,240 C260,160 520,300 780,220 C1020,148 1220,300 1440,220"
          fill="none"
          stroke="#1a2540"
          strokeOpacity="0.10"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}
